import {create} from 'zustand';
import Cookies from 'js-cookie';
import * as firebase from 'firebase/auth';
import {message} from 'antd';
import {t} from 'i18next';
import {DataResponse, GetTokenPayload, LoginPayloadType, User,} from '@/models';
import {API_ENDPOINTS, LoadingKeys} from '@/constants';
import {http} from '@/utils';
import {auth} from '@/lib/firebase';
import {handleApiCallInStore} from './utils';

const user = () => {
  const currentUser = Cookies.get('user');
  const token = Cookies.get('access_token');

  if (currentUser && currentUser !== 'undefined') {
    const {role, verified} = JSON.parse(currentUser);
    return {
      token,
      role,
      verified,
    };
  }
};

export const getToken = async (): Promise<DataResponse<GetTokenPayload>> => {
  const idToken = await auth.currentUser?.getIdToken(true);
  if (idToken) await Cookies.set('access_token', idToken);
  return await http.post<void, DataResponse<GetTokenPayload>>(
    API_ENDPOINTS.login
  );
};

export interface IAppState {
  mobileSidebarOpen: boolean;
  sidebarCollapsed: boolean;
  toggleSideBar: () => void;
  setSideBarCollapse: (state: boolean) => void;
  setSideMobileSidebarOpen: (state: boolean) => void;
  toggleMobileSidebar: () => void;
  currentUser: User | undefined;
  login: (data: LoginPayloadType, onSuccess: () => void) => void;
  logout: (onSuccess: () => void) => void;
}

export const useAppStore = create<IAppState>(set => ({
  sidebarCollapsed: false,
  mobileSidebarOpen: false,
  currentUser: user(),
  toggleMobileSidebar: () =>
    set(state => ({mobileSidebarOpen: !state.mobileSidebarOpen})),
  setSideMobileSidebarOpen: value => set(() => ({mobileSidebarOpen: value})),
  setSideBarCollapse: value => set(() => ({sidebarCollapsed: value})),
  toggleSideBar: () =>
    set(state => ({sidebarCollapsed: !state.sidebarCollapsed})),
  login: (data: LoginPayloadType, onSuccess: () => void) => {
    handleApiCallInStore(LoadingKeys.Login, async () => {
      const {email, password} = data;
      try {
        await firebase.signInWithEmailAndPassword(auth, email, password);
        const user = await getToken();
        Cookies.set('user', JSON.stringify(user?.data));
        if (user?.data?.token) {
          const expireTime = 1;
          Cookies.set('access_token', user?.data?.token, {
            expires: expireTime,
          });
        }
        set(() => ({currentUser: user?.data}));
        onSuccess?.();
      } catch (error) {
        message.error(error?.code || t('loginError'));
      }
    });
  },
  logout: async onSuccess => {
    await auth.signOut();
    await Cookies.remove('access_token');
    await Cookies.remove('user');
    set(() => ({currentUser: undefined}));
    onSuccess?.();
  },
}));
